import { render, staticRenderFns } from "./authority-letter-agen-print.vue?vue&type=template&id=40c2c5ec&scoped=true"
import script from "./authority-letter-agen-print.vue?vue&type=script&lang=js"
export * from "./authority-letter-agen-print.vue?vue&type=script&lang=js"
import style0 from "./authority-letter-agen-print.vue?vue&type=style&index=0&id=40c2c5ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c2c5ec",
  null
  
)

export default component.exports